export interface BrickErrorPayload {
  type?: string;
  cause?: Array<{ code: string | number; description: string }>;
  message?: string;
  [key: string]: unknown;
}

export const logFrontendError = async (
  context: string,
  error: BrickErrorPayload | unknown,
  extra?: {
    paymentMethod?: string;
    userEmail?: string;
  }
) => {
  try {
    const nav = window.navigator;
    await fetch('/api/health/log-error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        context,
        error: JSON.stringify(error),
        timestamp: new Date().toISOString(),
        url: window.location.href,
        browser: {
          userAgent: nav.userAgent,
          language: nav.language,
          vendor: nav.vendor,
        },
        paymentMethod: extra?.paymentMethod ?? null,
        userEmail: extra?.userEmail ?? null,
      }),
    });
  } catch {
    // fire-and-forget; swallow any network errors
  }
};

export const trackEvent = (action: string, params?: Record<string, any>) => {
  if (window.gtag) {
    window.gtag('event', action, params);
  }
};
